<template>  
    <div v-if="ready">
      <!-- <div>domainsZsd : {{ domainsZsd }}</div>
      <div>domainsColorZsd : {{ domainsColorZsd }}</div>      
      <div>domainsAutoScaleZsd : {{ domainsAutoScaleZsd }}</div>
      <div>sciPlotVariablesZsd : {{ sciPlotVariablesZsd }}</div>
      <div>datasZsd : {{ datasZsd }}</div>                   -->
      <!-- <textarea>
        {{ datas508 }}
      </textarea> -->    
      <button @click="saveConverted()">Convert</button>
      <div>{{ nbconterted }} / {{ migs.length }} -- {{ nberrors }} erreurs</div>
      <div v-if="converted">Convertion terminée</div>

    </div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { SecurityItemsKeys } from '@/enum/SecurityItems';
import { mustIgnoreValue } from '@/utils/autoscale';
import AdminMissionPlanTemplate from '@/components/admin/missionPlanTemplate/AdminMissionPlanTemplate.vue';
import { AloDbMissionPlanTemplate } from '@/models/alodb/AloDbMissionPlanTemplate';
import { AloDbMissionGlobal, AloDbMissionGlobalSimulation } from '@/models/alodb/AloDbMissionGlobal';
import { MissionGlobalType } from '@/enum/MissionGlobalType';
import { getDefaultSmartSimulation } from '@/models/iris/smartMission/ISmartSimulation';
import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState';
import { SIMULATION_SYNC_MISSSIONPLAN_SENSOR } from '@/store/modules/missionGlobal/mutation-types';
import apiAdminMissionGlobal from '@/api/admin/missionGlobal'

@Component({
  name: 'Test'  
})
export default class Debug extends Vue {    
  slugify = require('slugify')
  
  MISSION_ID = 2954
  nberrors = 0
  nbconterted = 0

  ready = false
  converted = false

  beforeRouteEnter(to:any,from:any,next:any) {         
     next((vm:Debug) => {              
       next(vm.$store.myGetters.userSecurity[SecurityItemsKeys.DEBUG_LOG].enable?'':'/login')
     })
  }

  async mounted() {
    // await this.$store.myActions.MISSION_ENSURE_MISSION(this.MISSION_ID)
    // await this.$store.myActions.MISSION_ENSURE_DATA_SCIENCE(this.MISSION_ID)
    await Promise.all([
      this.$store.myActions.MISSIONPLANTEMPLATE_ENSURE_LIST(),
      this.$store.myActions.ENSEIGNE_ENSURE_LIST()
    ])

    this.ready = true
  }

  get mitsToConvert() {
    return this.$store.myGetters.missionPlanTemplates.filter(m => !!m.MPT_LIBELLE && m.ENS_ID != 2 && m.ENS_ID != 3)
  }

  get migs(){
    return this.mitsToConvert.map(mit => this.convertMissionPlanTemplateToMig(mit)).filter(m => m.config?.mission_plan?.steps?.length)
  }


  convertMissionPlanTemplateToMig(mit:AloDbMissionPlanTemplate) {
    //@ts-ignore
    const admMig = new AloDbMissionGlobal({
      ENS_ID:mit.ENS_ID,
      MIG_TYP:MissionGlobalType.SIMULATION,
      MIG_LIBELLE:mit.MPT_LIBELLE,
      MIG_KEY:(this.slugify(mit.MPT_LIBELLE ?? '',{lower:true,replacement:'_',strict:true})).replace('template_from_mission_','').replace('template_mission_','').substring(0,32)
    }) 
    
    admMig.config = getDefaultSmartSimulation()
    admMig.config.mission_plan = MissionPlanUiState.parseMissionPlan(mit.MPT_JSON)
    this.$store.commit(SIMULATION_SYNC_MISSSIONPLAN_SENSOR, admMig)        

    return admMig as AloDbMissionGlobalSimulation
  }

  async saveConverted() {
    for(const mig of this.migs){
      try{
        await apiAdminMissionGlobal.saveMissionGlobal(mig) 
      }
      catch{
        this.nberrors++
      }
      finally{
        this.nbconterted++
      }
    }    
  }

  
  // get sciData() {
  //   return this.$store.myGetters.missionsById[this.MISSION_ID]?.dataScience
  // }


  // get sciPlotVariablesSoundVelocity() {
  //   return this.$store.myGetters.missionsById[this.MISSION_ID]?.sciPlotVariables?.find(v => v.name == "LEGATO_SOUND_VELOCITY")
  // }

  // get domainsZsd() {
  //   return this.$store.myGetters.missionsById[this.MISSION_ID]?.domains?.ALL?.ZSD
  // }

  // get domainsColorZsd() {
  //   return this.$store.myGetters.missionsById[this.MISSION_ID]?.domainsColor?.ALL?.ZSD
  // }

  // get domainsAutoScaleZsd() {
  //   return this.$store.myGetters.missionsById[this.MISSION_ID]?.domainsAutoScale?.ALL?.ZSD
  // }

  // get datasSoundVelocity() {
  //   return null
  //   //return this.$store.myGetters.missionsById[this.MISSION_ID]?.dataScience?.filter(!mustIgnoreValue(d.LEGATO_SOUND_VELOCITY))?.map(d => ({yosCycle:d.yosCycle,LEGATO_SOUND_VELOCITY:d.LEGATO_SOUND_VELOCITY,NAV_DEPTH:d.NAV_DEPTH}))
  // }

  // get datas508() {
  //   return this.$store.myGetters.missionsById[this.MISSION_ID]?.dataScience?.filter(d => d.yosCycle > 500 && d.yosCycle < 600)
  // }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
